import { useParams } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { formatDate, ia } from 'lib/helpers/utility';

import practiceState from 'components/practice/practiceState';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';
import { userState } from 'components/state';

import useShareWithPatient from '../hooks/useShareWithPatient';

const OrdersActionsCellRenderer = ({
  data,
  fromPatient,
  openEditModal,
  openPreviewModal,
  openDeleteModal,
  openPreviewResult
}) => {
  const currentPractice = useRecoilValue(practiceState.currentPractice);
  const user = useRecoilValue(userState);

  const { id } = useParams();
  const patientId = fromPatient ? user?.user_id : id;

  const unshare = !!data?.myportal;

  const { shareLoading, share, setShowConfirm, showConfirm } = useShareWithPatient({
    patientId,
    unshare
  });

  let options;

  if (fromPatient) {
    options = [
      {
        icon: 'eye-mono',
        label: 'Preview',
        onClick: () => {
          openPreviewModal({ type: data.rawType, id: data.id });
        }
      }
    ];
  } else {
    options = [
      {
        icon: 'eye-mono',
        label: 'Preview',
        onClick: () => {
          openPreviewModal({ type: data.rawType, id: data.id });
        }
      },
      {
        icon: 'trash-mono',
        label: 'Delete',
        onClick: () => {
          openDeleteModal({ type: data.rawType, orderId: data.id });
        }
      },
      {
        label: data?.myportal ? 'Unshare Order' : 'Share With Patient',
        icon: 'arrow-swap-down-mono',
        onClick: () => {
          setShowConfirm(true);
        }
      }
    ];

    if (data?.rawType !== 'elab_order') {
      options.splice(1, 0, {
        icon: 'edit-2-mono',
        label: 'Edit',
        onClick: () => {
          openEditModal({ type: data.rawType, id: data.id });
        }
      });
    }
  }

  if (ia(data?.results)) {
    options.splice(1, 0, {
      icon: 'status-mono',
      color: 'primary',
      stroke: true,
      label: 'View Result',
      children: data?.results.map((item) => ({
        icon: 'status-mono',
        label: item?.report_status || formatDate(item.created_at, currentPractice.timezone),
        onClick: () =>
          openPreviewResult({
            ...data,
            type: data.rawType,
            id: data.id,
            result: item,
            resultId: item.id
          })
      }))
    });
  }

  return (
    <div className="flex h-full w-full items-center justify-center">
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={options}
        isBorder={false}
      />
      <Confirm
        title={unshare ? 'Unshare Order' : 'Share Order'}
        secondaryBtnTxt="Cancel"
        handleClose={() => setShowConfirm(false)}
        icon="arrow-swap-down-mono"
        loading={shareLoading}
        primaryBtnTxt={unshare ? 'Unshare Order' : 'Share Order'}
        handleOpen={showConfirm}
        handleContinue={() => share({ type: data.rawType, id: data.id })}
        message={`Are you sure you want to ${unshare ? 'un' : ''}share the order with patient?`}
      />
    </div>
  );
};

export default OrdersActionsCellRenderer;
